import PaymentMethodItem from './PaymentMethodItem.component';

export default PaymentMethodItem;
